import { RECIPIENT_MAP_DATA } from "../actions/getRecipientMapData";

const defaultState = {
  data: {},
  loading: false,
  error: {},
};

const recipientMapData = (state = defaultState, action) => {
  switch (action.type) {
    case RECIPIENT_MAP_DATA.start:
      return {
        ...state,
        loading: true,
      };
    case RECIPIENT_MAP_DATA.end:
      return {
        ...state,
        loading: false,
      };
    case RECIPIENT_MAP_DATA.success:
      return {
        ...state,
        data: action.data,
      };
    case RECIPIENT_MAP_DATA.failed:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
};

export default recipientMapData;



// WEBPACK FOOTER //
// ./shared/reducers/recipientMapData.js